/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Feature_Pro_12Inputs */



/**
* | output |
* | --- |
* | "Transcription export (DocX, and CSV)" |
*
* @param {Signup_Feature_Pro_12Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_feature_pro_12 = /** @type {((inputs?: Signup_Feature_Pro_12Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Feature_Pro_12Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Transcription export (DocX, and CSV)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Transcription export (DocX, and CSV)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Transcription export (DocX, and CSV)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Transcription export (DocX, and CSV)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Transcription export (DocX, and CSV)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Transcription export (DocX, and CSV)")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Transcription export (DocX, and CSV)")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Transcription export (DocX, and CSV)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Transcription export (DocX, and CSV)")
	return /** @type {LocalizedString} */ ("Transcription export (DocX, and CSV)")
});